import React from "react";
import { Box, Typography } from "@mui/material";
import { UserAvatar } from "../UserAvatar";

export const Desktop = () => (
  <Box
    sx={{
      display: { xs: "none", md: "flex" },
      width: 1,
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Typography component="h1" variant="h6">
      TDS ERP
    </Typography>

    <UserAvatar />
  </Box>
);
